<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    style="height: 494px;"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-base text-blueGray-700">
            채널별 크롤링 데이터 비율
          </h3>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <!-- Chart -->
      <div class="relative h-350-px">
        <canvas ref="pieCanvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

export default {
  name: 'card-pie-chart',
  props: {
    chartData: {
      type: Object,
      default: () => ({
        press_count: 0,
        blog_count: 0,
        kin_count: 0,
        cafe_count: 0,
        community_count: 0,
        youtube_count: 0
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      handler(newVal) {
        console.log('CardPieChart - chartData changed:', newVal);
        this.updateChart();
      },
      deep: true
    }
  },
  mounted() {
    console.log('CardPieChart mounted - chartData:', this.chartData);
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    initChart() {
      // 기존 차트가 있으면 먼저 파괴
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }

      const ctx = this.$refs.pieCanvas;
      if (!ctx) return;

      const data = [
        this.chartData.press_count || 0,
        this.chartData.blog_count || 0,
        this.chartData.kin_count || 0,
        this.chartData.cafe_count || 0,
        this.chartData.community_count || 0,
        this.chartData.youtube_count || 0
      ];

      const config = {
        type: 'pie',
        data: {
          labels: ['언론', '블로그', '지식인', '카페', '커뮤니티', '유튜브'],
          datasets: [
            {
              data: data,
              backgroundColor: [
                '#FF6384',  // 언론 - 빨강
                '#36A2EB',  // 블로그 - 파랑
                '#FFCE56',  // 지식인 - 노랑
                '#4BC0C0',  // 카페 - 청록
                '#9966FF',  // 커뮤니티 - 보라
                '#FF9F40'   // 유튜브 - 주황
              ],
              borderWidth: 2,
              borderColor: '#fff'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                padding: 15,
                font: {
                  size: 12
                },
                generateLabels: (chart) => {
                  const datasets = chart.data.datasets;
                  return chart.data.labels.map((label, i) => {
                    const value = datasets[0].data[i];
                    const total = datasets[0].data.reduce((a, b) => a + b, 0);
                    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                    return {
                      text: `${label}`,
                      fillStyle: datasets[0].backgroundColor[i],
                      hidden: false,
                      index: i
                    };
                  });
                }
              }
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.label || '';
                  const value = context.parsed || 0;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                  return `${label}: ${value.toLocaleString()}건 (${percentage}%)`;
                }
              }
            }
          }
        }
      };

      this.chart = new ChartJS(ctx, config);
    },
    updateChart() {
      if (!this.chart || !this.chart.canvas) {
        // chart가 없거나 canvas가 분리된 경우 재생성
        this.$nextTick(() => this.initChart());
        return;
      }

      const data = [
        this.chartData.press_count || 0,
        this.chartData.blog_count || 0,
        this.chartData.kin_count || 0,
        this.chartData.cafe_count || 0,
        this.chartData.community_count || 0,
        this.chartData.youtube_count || 0
      ];

      this.chart.data.datasets[0].data = data;
      this.chart.update();
    }
  }
};
</script>

<style scoped>
.h-350-px {
  height: 350px;
}
</style>
